// extracted by mini-css-extract-plugin
export default {"header":"TeacherClassView_header__uLrn2","pointer":"TeacherClassView_pointer__PwWrW","sessionItem":"TeacherClassView_sessionItem__gsOmy"};